import { Row } from 'antd'
import Alert from 'app/components/UI-Elements/Feedback/Alert'
import Button from 'app/components/UI-Elements/General/Button'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { RecordType } from 'app/constants/GlobalTypes'
import { useCurrentCustomer } from 'app/lib/hooks/useCurrent'
import { useMutation } from 'app/lib/hooks/useMutation'
import useTranslation from 'app/lib/hooks/useTranslation'
import { queries, RecordTypeEnum } from 'app/queries'
import React from 'react'

const CallToActionInfo: React.FC = () => {
  const customer = useCurrentCustomer()
  const { tButtonTitle, tCore } = useTranslation({
    recordType: RecordType.price_list,
    componentType: 'core',
    scope: 'info'
  })
  const { execute, loading, called } = useMutation(queries.hubspotTicket.create, {
    recordType: RecordTypeEnum.hubspotTicket,
    action: 'create'
  })

  const contactName = customer?.customer_owner_name || customer?.owner_name

  const onClick = () => execute({})

  return (
    <Alert type="default">
      <h4 className="text-black">{tCore({ id: 'title' })}</h4>
      <Row wrap={false} gutter={[24, 0]}>
        <KCol flex="auto">{tCore({ id: 'description' }, { contactName })}</KCol>
        <KCol>
          <Button
            type="primary"
            disabled={called}
            loading={loading}
            onClick={onClick}
            title={tButtonTitle({ id: 'request_price_list' })}
          />
        </KCol>
      </Row>
    </Alert>
  )
}

export default CallToActionInfo
